module.exports = __webpack_public_path__ + "img/4_05.6d02e2b6.png";